import { useState } from "react";
import "./App.css";
import { Navigate, Route, Routes } from "react-router-dom";
import Welcome from "./containers/pages/Welcome";
import Body from "./containers/pages/home/Body";
import Setup from "./containers/pages/Setup";
import ManualControl from "./containers/pages/manualControl/ManualControl";
import Export from "./containers/pages/Export";
import ChartPage from "./containers/pages/ChartPage";
import AccountSettings from "./containers/pages/AccountSettings";
import Devices from "./containers/pages/Devices";
import Requests from "./containers/pages/Requests";
import PastRequests from "./containers/pages/History";
import CalculateThrust from "./containers/pages/CalculateThrust";
import HistoryVisualization from "./containers/pages/HistoryVisualization";
import ComparisonPage from "./containers/pages/ComparisonPage";
import { PortDataProvider } from "./contexts/PortDataContext";
import { ThemeProvider } from "@mui/material";
import { useThemeContext } from "../utils/ThemeContext";
import { darkTheme, lightTheme } from "./AppTheme";
import { ROUTES } from "../routes";

export const THRUST_STAND_BASE_PATH = ROUTES.thrustStand;

/**
 * Standalone Thrust Stand feature mounted inside the Developer portal.
 * It reuses the portal router, authenticated Redux store and theme, so this
 * project has no runtime dependency on the original thrust-stand-ui project.
 */
function ThrustStandApp() {
  const [ipAddress, setIpAddress] = useState("");
  const { themeMode } = useThemeContext();
  const thrustStandTheme = themeMode ? darkTheme : lightTheme;

  return (
    <ThemeProvider theme={thrustStandTheme}>
        <PortDataProvider>
          <div
            className="thrust-stand-app"
            style={{
              backgroundColor: thrustStandTheme.palette.primary.main,
              color: thrustStandTheme.palette.text.primary,
            }}
          >
          <Routes>
            <Route index element={<Welcome />} />
            <Route path="thrusts" element={<Devices />} />
            <Route path="requests" element={<Requests />} />
            <Route path="calculate" element={<CalculateThrust />} />
            <Route path="history" element={<PastRequests />} />
            <Route path="visualize" element={<HistoryVisualization />} />
            <Route path="compare" element={<ComparisonPage />} />
            <Route
              path="thrusts/:deviceId"
              element={<Body ipAddress={ipAddress} setIpAddress={setIpAddress} />}
            >
              <Route index element={<Setup />} />
              <Route path="setup" element={<Setup />} />
              <Route
                path="manual-control"
                element={
                  <ManualControl
                    ipAddress={ipAddress}
                    setIpAddress={setIpAddress}
                  />
                }
              />
              <Route path="export" element={<Export />} />
              <Route path="charts/:chartKey" element={<ChartPage />} />
              <Route path="account-settings" element={<AccountSettings />} />
            </Route>
            <Route path="*" element={<Navigate to={THRUST_STAND_BASE_PATH} replace />} />
          </Routes>
          </div>
        </PortDataProvider>
    </ThemeProvider>
  );
}

export default ThrustStandApp;
